import React from "react"

export type TTransitionContext = {
  transition: React.MutableRefObject<number | null>
  startTransition: () => void
}

export const TransitionContext = React.createContext<TTransitionContext | null>(null)

export default function useTransitionHook(props: {children: React.ReactNode}) {
  const transition = React.useRef<number | null>(null)

  const startTransition = React.useCallback(() => {
    const timerId = setInterval(() => {
      transition.current = (transition.current ?? 0) + 0.025
      if(transition.current >= 1) {
        clearInterval(timerId)
        transition.current = null
      }
    }, 33)
  }, [])

  const value = React.useMemo(() => ({
    transition,
    startTransition
  }), [])

  return (
    <TransitionContext.Provider value={value}>
      {props.children}
    </TransitionContext.Provider>
  )
}
